<div *ngIf="showPublic" class="admin__disclaimer">
  <div class="form__inputmark mr-15">
    <i class="fa-light fa-circle-exclamation"></i>
    <span translate>admin.messages.public</span>
  </div>
  <span>{{ 'admin.messages.disclaimerpublic' | translate }}</span>
</div>

<div *ngIf="showRequired" class="admin__disclaimer">
  <div class="admin__disclaimer-required mr-15"> </div>
  <span>{{ 'admin.messages.disclaimerneeded' | translate }}</span>
</div>
